import * as React from "react";
import { PaginationItemProps } from "../../../../data";

export class PaginationItem extends React.Component<PaginationItemProps, {}> {
    render() {
        return (
            <button
                type="button"
                className="rj-superbanner__pagination-item"
                data-page-current={this.props.isCurrent}
                data-page-id={this.props.id}
                onClick={this.props.handler}
                data-uat="button-superbanner-pagination-item">
            </button>
        );
    }
}